import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import {
  MobileEndUsersPage,
  MobilePlansPage,
  MobileStatisticsPage,
  MobileSimAndLineManagementPage,
  MobilePhoneNumberManagementPage,
  MobileGroupsPage,
} from './pages';
import { Mobile } from './mobile.setup';

export const MobileModule: ProductLinePermission = {
  id: Mobile.id,
  title: 'PAGE.MOBILE.TITLE',
  path: Mobile.path,
  pages: [
    MobileEndUsersPage,
    MobileGroupsPage,
    MobilePlansPage,
    MobileStatisticsPage,
    MobileSimAndLineManagementPage,
    MobilePhoneNumberManagementPage,
  ],
  showInSidebar: true,
  iconClass: 'fal fa-mobile-alt',
};
